module.exports = __webpack_public_path__ + "static/img/we.b4686d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/we.png
// module id = c0My
// module chunks = 1